var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0494 12.8017C24.8874 12.5125 24.5817 12.3334 24.25 12.3334H17.9131L18.747 2.32637C18.7819 1.90745 18.5272 1.51856 18.1293 1.38295C17.7332 1.24642 17.2923 1.3991 17.064 1.75225L6.98083 17.3354C6.79818 17.6174 6.78432 17.9767 6.94502 18.2716C7.10572 18.5666 7.41453 18.75 7.7502 18.75H14.0934L13.2528 29.6797C13.2202 30.1022 13.4815 30.4921 13.8848 30.6224C13.9779 30.6523 14.0728 30.6667 14.1668 30.6667C14.4792 30.6667 14.7791 30.5061 14.9492 30.2281L25.0324 13.7282C25.2052 13.4454 25.2119 13.0908 25.0494 12.8017ZM15.3731 26.018L15.9974 17.9038C16.0171 17.6491 15.9294 17.3979 15.7562 17.2104C15.5825 17.0233 15.3386 16.9167 15.0835 16.9167H9.43537L16.616 5.81892L16.0033 13.1741C15.9822 13.4297 16.0686 13.682 16.2423 13.8709C16.4159 14.0594 16.6603 14.1667 16.9168 14.1667H22.6155L15.3731 26.018Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.4c5647637421e6c54fcf9c913da660b7.svg";
export { ForwardRef as ReactComponent };